module.exports = __webpack_public_path__ + "static/speaking-e1a8979de08392d4fa119922e7207f24.jpg";